<template>
  <div class="detail-wrap">
    <div class="detail-title">
      Transaction Details - <span style="color:#7B70F0;">{{ $route.query.id }}</span>
    </div>
    <b-card
      class="mt-2"
      title="Basic Info"
    >
      <hr>
      <b-row class="mt-2">
        <b-col
          v-for="(item, index) in infos"
          :key="index"
          md="4"
          class="mb-2"
        >
          <b-row>
            <b-col
              md="6"
              class="info-key"
            >
              {{ item.key }}
            </b-col>
            <b-col
              v-if="item.key === 'Merchant ID'"
              md="6"
              class="info-value"
            >
              <b-link
                :to="{
                  path: '/merchant-detail',
                  query: { id: item.value, timezone: timeZone },
                }"
                class="font-weight-bold cursor-pointer"
                target="_blank"
              >
                {{ item.value }}
              </b-link>
            </b-col>
            <b-col
              v-else-if="item.key === 'Attachment'"
              md="6"
              class="info-value"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="flat-primary"
                size="sm"
                class="cursor-pointer"
                @click="viewImage"
              >
                View
              </b-button>
            </b-col>
            <b-col
              v-else
              md="6"
              class="info-value"
            >
              {{ item.value }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      title="Financial Info"
    >
      <hr>
      <b-row class="mt-2">
        <b-col
          v-for="(item, index) in financialInfos"
          :key="index"
          md="4"
          class="mb-2"
        >
          <b-row>
            <b-col
              md="6"
              class="info-key"
            >
              {{ item.key }}
            </b-col>
            <b-col
              md="6"
              class="info-value"
            >
              {{ item.value }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      title="Payer Bank Account Info"
    >
      <hr>
      <b-row class="mt-2">
        <b-col
          v-for="(item, index) in bankAccountInfos"
          :key="index"
          md="4"
          class="mb-2"
        >
          <b-row>
            <b-col
              md="6"
              class="info-key"
            >
              {{ item.key }}
            </b-col>
            <b-col
              md="6"
              class="info-value"
            >
              {{ item.value }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      title="History"
    >
      <hr>
      <table-list
        :table-data.sync="tableData"
        :list.sync="tableList"
        :page-num.sync="currentPage"
        :total-list.sync="totalList"
      />
      <b-button
        class="operation"
        variant="primary"
        @click="operation"
      >Operation</b-button>
    </b-card>

    <b-modal
      ref="image-modal"
      :no-close-on-backdrop="true"
      title=""
      cancel-variant="outline-secondary"
      size="lg"
      hide-footer
      centered
    >
      <b-img
        :src="modalImage"
        fluid
        alt="Responsive image"
        style="cursor: pointer;"
        @click="$previewPictrue(modalImage)"
      />
    </b-modal>

    <!-- modal -->
    <b-modal
      ref="manage-this-deposit"
      title="Manage This Deposit"
      ok-only
      ok-title="Submit"
      footer-class="manage-this-footer"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        class="mt-1 pl-3 pr-3"
        @submit.stop.prevent="handleSubmit"
      >
        <b-row>
          <b-col
            cols="12"
            sm="12"
          >
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="name-input">Status</label>
              </div>
              <v-select
                v-model="manageStatus"
                :options="statusOption"
                :clearable="false"
              />
            </b-form-group></b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="12"
          >
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="name-input">Remark</label>
              </div>
              <b-form-textarea
                v-model="manageRemark"
                autocomplete="off"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="12"
          >
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="name-input">Password</label>
              </div>
              <b-input-group>
                <b-form-input
                  v-model="managePassword"
                  :type="passwordFieldType"
                  autocomplete="off"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>

  </div>
</template>

<script>
import {
  defineComponent, getCurrentInstance, ref, computed, onMounted,
} from '@vue/composition-api'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BImg,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default defineComponent({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BLink,
    BImg,
    vSelect,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const { $store } = proxy
    const infos = ref([
      { key: 'Transaction ID', value: 'SGDH23476436482DDFHS' },
      { key: 'Merchant Name', value: 'TEST1234' },
      { key: 'Status', value: 'PROCESSING' },
      { key: 'Date Submitted', value: '2023-04-12 14:34' },
      { key: 'Remark', value: 'TEST TRANSACTION' },
      { key: 'Transaction Date', value: '2023-04-12 14:34' },
      { key: 'Merchant ID', value: 'AIUYSCGAUYGD128497' },
      { key: 'Attachment', value: '' },
      { key: 'Admin Remark', value: '' },
    ])
    const financialInfos = ref([
      { key: 'Amount Submitted', value: '100' },
      { key: 'Currency', value: 'BRL' },
      { key: 'Amount Recieved', value: '100' },
    ])
    const bankAccountInfos = ref([
      { key: 'Bank Account Number', value: '1546546' },
    ])
    const modalImage = ref('')
    const viewImage = () => {
      // 显示图片
      proxy.$refs['image-modal'].show()
      modalImage.value = 'https://picsum.photos/1024/400/?image=41'
    }
    const timeZone = computed(() => $store.state.wallet.timeZone, { immediate: true, deep: true })

    // history
    const currentPage = ref(1)
    const tableList = ref([
      {
        status: 'Test Smith', date: '1685604068', description: 'test description',
      },
    ])
    const totalList = ref(0)
    const tableData = ref({
      tableColumns: [
        { key: 'status', label: 'Status' },
        { key: 'date', label: 'Date' },
        { key: 'description', label: 'Description' },
      ],
      templates: [
        { key: 'date', tType: 'datetime' },
      ],
    })

    const operation = () => {
      proxy.$refs['manage-this-deposit'].show()
    }
    const statusOption = ref([
      { label: 'FAILED', value: 'FAILED' },
      { label: 'REJECTED', value: 'REJECTED' },
    ])
    const manageStatus = ref('')
    const manageRemark = ref('')
    const managePassword = ref('')
    const resetModal = () => {
      manageStatus.value = ''
      manageRemark.value = ''
      managePassword.value = ''
    }
    const handleOk = () => {}

    const depositDetail = ref()
    onMounted(() => {
      setTimeout(() => {
        depositDetail.value = {
          basic_info: {
            transaction_id: '', // string
            merchant_name: '', // string
            merchant_sn: '', // string
            transaction_status: 0, // 1 成功, 2 失败, 3 处理中 number
            created_at: '', // string
            transaction_at: '', // string
            remark: '', // string
            admin_remark: '', // string
          },
          financial_info: {
            amount_submitted: '', // string
            amount_re: '', // string
            precessing_fee: '', // string
            currency: '', // string
          },
          payer_info: {
            bank_country: '', // string
            bank_name: '', // string
            account_name: '', // string
            bank_account_number: '', // string
            address: '', // string
            bank_branch: '', // string
            swift_code: '', // string
            currency: '', // string
          },
          payee_info: {
            bank_country: '', // string
            bank_name: '', // string
            account_name: '', // string
            bank_account_number: '', // string
            address: '', // string
            bank_branch: '', // string
            swift_code: '', // string
            currency: '', // string
          },
          serial_list: [
            {
              serial_id: '', // string
              creation_data: '', // string
              amount: '', // string
              arrival_amount: '', // string
            },
          ],
        }
      }, 1000)

      // proxy.$showLoading()
      // const res = await proxy.$api.fetchMerchantTransactionDetail({ merchant_id: proxy.$route.query.id }).catch(() => { proxy.$hideLoading() })
      // proxy.$hideLoading()
      // if (!res) { return }
      // const { code, data, message } = res.data
      // if (code === 200) {
      //   console.log(data)
      // } else {
      //   proxy.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: 'Notification',
      //       icon: 'BellIcon',
      //       text: `${message}`,
      //       variant: 'danger',
      //     },
      //   }, {
      //     position: 'top-center',
      //   })
      // }
    })

    return {
      infos,
      financialInfos,
      bankAccountInfos,
      modalImage,
      viewImage,
      timeZone,

      tableData,
      tableList,
      currentPage,
      totalList,

      operation,
      statusOption,
      manageStatus,
      manageRemark,
      managePassword,
      resetModal,
      handleOk,
    }
  },
  directives: {
    Ripple,
  },
})
</script>

<style lang="scss">
.detail-wrap {
  width: 95%;
  padding: 4rem 0;
  margin: 0 auto;
  min-height: 400px;
  .detail-title {
    font-size: 24px;
  }
  .info-key {
    color: #333333;
  }
  .info-value {
    color: #AAAAAA;
  }
  .operation {
    position: absolute;
    top: 15px;
    right: 40px;
    cursor: pointer;
  }
}
  .manage-this-footer {
    justify-content: center;
  }
</style>
